module.exports = __webpack_public_path__ + "img/settings-active.b7b82a61.svg";